import { render, staticRenderFns } from "./PriceControlDetail.vue?vue&type=template&id=426cf850&scoped=true&"
import script from "./PriceControlDetail.vue?vue&type=script&lang=js&"
export * from "./PriceControlDetail.vue?vue&type=script&lang=js&"
import style0 from "./PriceControlDetail.vue?vue&type=style&index=0&id=426cf850&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "426cf850",
  null
  
)

export default component.exports